import { TextType } from './types'

export const TEXT: Record<TextType, string> = {
    user: 'Crie um novo usuário.',
    agent: 'Crie um agente financeiro.',
    agentLink: 'Vincule um agente financeiro.',
    group: 'Crie um novo grupo.',
    institution: 'Crie uma nova instituição financeira.',
    contract: 'Crie um novo contrato.',
    search: 'Verifique o termo pesquisado.',
    lote: 'Crie um novo lote.'
}
